<template>
  <div>
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">销售状况</div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- <el-form-item label="城市">
          <el-select size="small" v-model="searchForm.hotel_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in 5" :key="index" :label="item.name" :value="item.hotel_id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="">
          <el-radio-group v-model="searchForm.type" size="medium">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="today">今日</el-radio-button>
            <el-radio-button label='7day'>近七天</el-radio-button>
            <el-radio-button label='15day'>近十五天</el-radio-button>
            <el-radio-button label='month'>近一个月</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="时间筛选">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-col>
      <el-col :span="12" style="border-right:1px solid #eee">
        <!-- 第一行 -->
        <el-row type="flex" class="row-bg">
          <el-col v-for="(item, index) in totalNumObj.data1" :key="index" :span="4">
            <div class="f-b-c">
              <div>
                <span class="tubiao icon iconfont" :class="item.iconClass" :style="{ background: item.color}"></span>
              </div>
              <div class="word-box">
                {{ item.label }}
                <el-tooltip class="item" v-if="item.showTooltip" effect="dark" :content="item.content" placement="top-start">
                  <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
                </el-tooltip>
              </div>
              <div :style="{ color: item.color, fontSize: '24px' }">{{ item.value }}</div>
            </div>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row type="flex" class="row-bg">
          <el-col v-for="(item, index) in totalNumObj.data2" :key="index" :span="4">
            <div class="f-b-c">
              <div>
                <span class="tubiao icon iconfont" :class="item.iconClass" :style="{ background: item.color}"></span>
              </div>
              <div class="word-box">
                {{ item.label }}
                <el-tooltip class="item" v-if="item.showTooltip" effect="dark" :content="item.content" placement="top-start">
                  <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
                </el-tooltip>
              </div>
              <div :style="{ color: item.color, fontSize: '24px' }">{{ item.value }}</div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 第二列 -->
      <el-col :span="12">
        <!-- 第一行 -->
        <el-row type="flex" class="row-bg">
          <el-col v-for="(item, index) in totalNumObj.data3" :key="index" :span="4">
            <div class="f-b-c">
              <div>
                <span class="tubiao icon iconfont" :class="item.iconClass" :style="{ background: item.color}"></span>
              </div>
              <div class="word-box">
                {{ item.label }}
                <el-tooltip class="item" v-if="item.showTooltip" effect="dark" :content="item.content" placement="top-start">
                  <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
                </el-tooltip>
              </div>
              <div :style="{ color: item.color, fontSize: '24px' }">{{ item.value }}</div>
            </div>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row type="flex" class="row-bg">
          <el-col v-for="(item, index) in totalNumObj.data4" :key="index" :span="4">
            <div class="f-b-c">
              <div>
                <span class="tubiao icon iconfont" :class="item.iconClass" :style="{ background: item.color}"></span>
              </div>
              <div class="word-box">
                {{ item.label }}
                <el-tooltip class="item" v-if="item.showTooltip" effect="dark" :content="item.content" placement="top-start">
                  <i class="el-tooltip icon iconfont icon-gantanhao gray item"></i>
                </el-tooltip>
              </div>
              <div :style="{ color: item.color, fontSize: '24px' }">{{ item.value }}</div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-col>

  </div>
</template>
<script>
import StatisticsApi from "@/api/statistics.js";
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      searchForm: {
        city_id: "",
        type: "all",
        createTime: ""
      },
      totalNumObj: {}, // 四列总数据
    };
  },
  inject: ["dataModel"],
  created() {
    this.getData();
    // console.log("==========", this.dataModel);
  },
  methods: {
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.type = self.searchForm.type;
      StatisticsApi.getsalesicon(Params, true)
        .then(res => {
          self.loading = false;
          self.totalNumObj = res.data;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.row-bg {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}
.flex-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.f-b-c {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10px auto;
  /* margin: 20px 0; */
}
.word-box {
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  margin: 10px 0;
}
.tubiao {
  color: #fff;
  padding: 10px;
  width: 50px;
  color: #fff;
  background: #37a5f3;
  border-radius: 50%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/Total.vue